import { useState, useEffect } from "react";
import { Spin } from "antd";

export default function BundledEditor(props) {
  const [loadingEditor, setLoadingEditor] = useState(true);
  const [EditorComponent, setEditorComponent] = useState(null);

  useEffect(() => {
    const loadEditor = async () => {
      setLoadingEditor(true);
      try {
        await import("tinymce/tinymce");
        await import("tinymce/models/dom/model");
        await import("tinymce/themes/silver");
        await import("tinymce/icons/default");
        await import("tinymce/skins/ui/oxide/skin");

        await import("tinymce/plugins/advlist");
        await import("tinymce/plugins/anchor");
        await import("tinymce/plugins/autolink");
        await import("tinymce/plugins/autoresize");
        await import("tinymce/plugins/autosave");
        await import("tinymce/plugins/charmap");
        await import("tinymce/plugins/code");
        await import("tinymce/plugins/codesample");
        await import("tinymce/plugins/directionality");
        await import("tinymce/plugins/emoticons");
        await import("tinymce/plugins/fullscreen");
        await import("tinymce/plugins/help");
        await import("tinymce/plugins/help/js/i18n/keynav/en");
        await import("tinymce/plugins/image");
        await import("tinymce/plugins/importcss");
        await import("tinymce/plugins/insertdatetime");
        await import("tinymce/plugins/link");
        await import("tinymce/plugins/lists");
        await import("tinymce/plugins/media");
        await import("tinymce/plugins/nonbreaking");
        await import("tinymce/plugins/pagebreak");
        await import("tinymce/plugins/preview");
        await import("tinymce/plugins/quickbars");
        await import("tinymce/plugins/save");
        await import("tinymce/plugins/searchreplace");
        await import("tinymce/plugins/table");
        await import("tinymce/plugins/visualblocks");
        await import("tinymce/plugins/visualchars");
        await import("tinymce/plugins/wordcount");
        await import("tinymce/plugins/emoticons/js/emojis");
        await import("tinymce/skins/content/default/content");
        await import("tinymce/skins/ui/oxide/content");

        const { Editor } = await import("@tinymce/tinymce-react");
        setEditorComponent(() => Editor);
      } catch (error) {
        console.error("Error loading TinyMCE:", error);
      } finally {
        setLoadingEditor(false);
      }
    };

    loadEditor();
  }, []);

  if (loadingEditor) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Spin size="large" />
        <p>Loading Editor...</p>
      </div>
    );
  }

  return <EditorComponent licenseKey="gpl" {...props} />;
}
